import { ProductInclusion } from "../../../../../../graphql/operations";
import Inclusion from "../Inclusion";
import s from "./InclusionsGrid.module.scss";
import useWindowSize from "../../../../../../utils/useWindowSize";

type InclusionsGridProps = {
  inclusions: ProductInclusion[];
  onOpenModal?: () => void;
};

export default function InclusionsGrid({
  inclusions,
  onOpenModal,
}: InclusionsGridProps) {
  const isMobileScreen = useWindowSize().isMobile;

  return (
    <div className={s.Grid}>
      {inclusions.map((inclusion) => (
        <Inclusion
          key={inclusion.id}
          inclusion={inclusion}
          onReadMore={isMobileScreen ? undefined : onOpenModal}
        />
      ))}
    </div>
  );
}
